import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/app/store';
import { WorkOrderFull, WorkOrderSimple, WorkOrderState } from './works-orders.interface';

// Thunks para Ordenes de Trabajo
import * as thunks from './works-ordersThunks';
import { APIResponse } from '@/types/custom-http';


const initialState: WorkOrderState = {
  itemsSimples: [],
  itemsFull: [],
  workOrder: null,
  loading: false,
  error: null,
};



// Slice
const worksordersSlice = createSlice({
  name: 'workorders',
  initialState,
  reducers: {
    clearWorkOrdersSimple: (state) => {
      state.itemsSimples = [];
    },
    clearWorkOrdersFull: (state) => {
      state.itemsFull = [];
    },
    clearSelectedWorkOrder: (state) => {
      state.workOrder = null;
    },
    clearWorksOrdersError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Obtener Listado Simple de Ordenes de Trabajo
      .addCase(thunks.fetchWorkOrdesSimple.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchWorkOrdesSimple.fulfilled, (state, action: PayloadAction<APIResponse<WorkOrderSimple[]>>) => {
        state.loading = false;
        if(action.payload.data){
          state.itemsSimples = action.payload.data;
        }
      })
      .addCase(thunks.fetchWorkOrdesSimple.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Obtener Listado Completo de Ordenes de Trabajo
      .addCase(thunks.fetchWorkOrdersFull.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchWorkOrdersFull.fulfilled, (state, action: PayloadAction<APIResponse<WorkOrderFull[]>>) => {
        state.loading = false;
        if(action.payload.data){
          state.itemsFull = action.payload.data;
        }
      })
      .addCase(thunks.fetchWorkOrdersFull.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })


      // Obtener un producto específico por ID
      .addCase(thunks.fetchWorkOrderById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.fetchWorkOrderById.fulfilled, (state, action: PayloadAction<APIResponse<WorkOrderFull>>) => {
        state.loading = false;
        if(action.payload.data){
          state.workOrder = action.payload.data;
        }
      })
      .addCase(thunks.fetchWorkOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })

      // Crear un nuevo producto
      .addCase(thunks.createWorkOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(thunks.createWorkOrder.fulfilled, (state, action: PayloadAction<APIResponse<WorkOrderSimple>>) => {
        state.loading = false;
        if(action.payload.data){
          state.itemsSimples.push(action.payload.data);
        }
      })
      .addCase(thunks.createWorkOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message as string;
      })
      
  },
});

// Selectors
export const selectAllWorksOrdersSimple = (state: RootState) => state.workorders.itemsSimples;
export const selectAllWorksOrdersFull = (state: RootState) => state.workorders.itemsFull;
export const selectedWorkOrder = (state: RootState) => state.workorders.workOrder;
export const selectProductLoading = (state: RootState) => state.products.loading;
export const selectProductError = (state: RootState) => state.products.error;

// Actions
export const { clearSelectedWorkOrder, clearWorkOrdersFull,  clearWorkOrdersSimple, clearWorksOrdersError} = worksordersSlice.actions;

export default worksordersSlice.reducer;